import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {AccountUserXrefEntity} from './account.user.xref.entity';
import {SystemEntity} from './system.entity';
import {PersonEntity} from "./person.entity";

@EntityTable('account', '81f566e3-b3a4-4776-a691-52fb5043d30c')
export class AccountEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.LONG)
    public kind: number; // {0: root, 1: third... vendor... client ... free... trial}

    @Column(FieldTypeKind.GUID)
    public ownerId: string;

    @JoinColumn(FieldTypeKind.GUID, PersonEntity, true, false, FieldRelationKind.BELONGS_TO, 'person')
    public personId: string;

    @Transient('system', FieldRelationKind.HAS_MANY, 'accountId')
    public systems: SystemEntity[];

    @Transient('account_user_xref', FieldRelationKind.HAS_MANY, 'accountId')
    public users: AccountUserXrefEntity[];

    @Transient('account_user_invite', FieldRelationKind.HAS_MANY, 'accountId')
    public invites: AccountUserXrefEntity[];

    @Column(FieldTypeKind.LONG)
    public status: number; // {0: root, 1: third... vendor... client ... free... trial}
}
